<template>
	<div class="date-pickers-wrapper" :class="[calendarDirection]">
		<!-- From Date InputCalendar -->
		<input-calendar
		:id="fromDateParams.domIdentifier"
		:params="fromDateParams"
		:inputValue="fromDateParams.inputValue"
		:disabledDates="fromDateDisableDates"
		@input="emit('inputFromDate', $event)"/>
		<!-- To Date InputCalendar -->
		<input-calendar
		class="to-date"
		:id="toDateParams.domIdentifier"
		:params="toDateParams"
		:inputValue="toDateParams.inputValue"
		:disabledDates="toDateDisableDates"
		@input="emit('inputToDate', $event)"/>
    </div>
</template>

<script setup>
/* Components */
import InputCalendar from '@/components/generic/inputs/Calendar'

/* Vue, Helpers Imports */
import { computed } from 'vue'
import moment from '@/assets/setups/moment'

/* Emmitters */
const emit = defineEmits(['inputFromDate', 'inputToDate'])

/** props received
@calendarDirection {String} [column (default), row]
@dateWindowSize {Number} max days allowed between init and end date
@fromDateParams {
	- domIdentifier {String} id to apply in our component, for mandatory logic
	- labelText {String} label for textField
    - darkBackgroundVariant {Boolean} property to apply specific colors for blue backgrounds
    - bottomMessage {String} text to display in bottom elements
	- inputValue {String, Number, Date} value to be displayed in input
	- disabledDates {Object} - {to: minDate, from: maxDate }
	- errorState {Boolean} property to show if input has error or not
	- disabled {Boolean}
}
@toDateParams {
	- domIdentifier {String} id to apply in our component, for mandatory logic
	- labelText {String} label for textField
    - darkBackgroundVariant {Boolean} property to apply specific colors for blue backgrounds
    - bottomMessage {String} text to display in bottom elements
	- inputValue {String, Number, Date} value to be displayed in input
	- disabledDates {Object} - {to: minDate, from: maxDate }
	- errorState {Boolean} property to show if input has error or not
	- disabled {Boolean}
}
*/
const props = defineProps({
	calendarDirection: String,
    dateWindowSize: Number,
	fromDateParams: Object,
	toDateParams: Object
})

const fromDateDisableDates = computed(() => {
	const fromDateValidation = props.toDateParams.inputValue
							? new Date(props.toDateParams.inputValue)
							: (props.fromDateParams.disabledDates ? props.fromDateParams.disabledDates.from : null)

    let toDateValidation = props.toDateParams.disabledDates ? props.toDateParams.disabledDates.to : null

    if (props.dateWindowSize &&
        props.toDateParams.inputValue &&
        new Date(moment(props.toDateParams.inputValue).subtract(props.dateWindowSize, 'days')) < new Date(fromDateValidation)) {
        toDateValidation = new Date(moment(props.toDateParams.inputValue).subtract(props.dateWindowSize, 'days'))
    }

	return {
		to: toDateValidation,
		from: fromDateValidation
	}
})

const toDateDisableDates = computed(() => {
	const toDateValidation = props.fromDateParams.inputValue
							? new Date(props.fromDateParams.inputValue)
							: (props.toDateParams.disabledDates ? props.toDateParams.disabledDates.to : null)

    let fromDateValidation = props.fromDateParams.disabledDates ? props.fromDateParams.disabledDates.from : null

    if (props.dateWindowSize &&
        props.fromDateParams.inputValue &&
        new Date(moment(props.fromDateParams.inputValue).add(props.dateWindowSize, 'days')) < new Date(fromDateValidation)) {
        fromDateValidation = new Date(moment(props.fromDateParams.inputValue).add(props.dateWindowSize, 'days'))
    }

	return {
		to: toDateValidation,
		from: fromDateValidation
	}
})
</script>

<style lang="scss" scoped>
.date-pickers-wrapper {
    width: 100%;

    display: flex;
    flex-direction: column;
	gap: 24px;

	&.row {
		width: fit-content;
		flex-direction: row;
		gap: 16px;
	}
}
</style>
